import React from "react";
import { useSelector } from "react-redux";
import { selectSkyHarvester } from "../../../redux/selectors";

const PrintSkyHarvester = () => {
  const skyHarvesterDetails = useSelector(selectSkyHarvester);

  const isZoneEmpty = (detail) => {
    return (
      !detail.TankSize &&
      !detail.TankQuantity &&
      !detail.WatertronicsProvidedTank &&
      !detail.ProvidedTankDetails &&
      !detail.Comments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter((detail) => detail && detail.HasSky && Object.keys(detail).length > 0)
          .map((detail, index) => {
            if (isZoneEmpty(detail)) {
              return null;
            }
            return (
              <div className="section" key={index}>
                <table className="table table-bordered full-width">
                  <tbody>
                    <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Tank Size: </strong>{detail.TankSize}</td></tr>
                            <tr><td><strong>Tank Quantity: </strong>{detail.TankQuantity}</td></tr>
                            <tr><td><strong>Watertronics Provided Tank: </strong>{detail.WatertronicsProvidedTank}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Provided Tank Details: </strong>{detail.ProvidedTankDetails}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.Comments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      {skyHarvesterDetails && skyHarvesterDetails.some(detail => detail.HasSky) && (
        <h2 className="print-section-header">SkyHarvester Summary</h2>
      )}
      {renderDetails(skyHarvesterDetails)}
    </div>
  );
};

export default PrintSkyHarvester;
